import { render, staticRenderFns } from "./ReceivableAging.vue?vue&type=template&id=20f5eef0&scoped=true"
import script from "./ReceivableAging.vue?vue&type=script&lang=js"
export * from "./ReceivableAging.vue?vue&type=script&lang=js"
import style0 from "./ReceivableAging.vue?vue&type=style&index=0&id=20f5eef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f5eef0",
  null
  
)

export default component.exports